import type { SkyspirePlayer, SkyspireRegion } from '../services/skyspireApi';

const hkNames = [
  '星河行者',
  '霜境歌者',
  '星语使者',
  '云海初弦',
  'AzureWind',
  '晨光初现',
  '星尘旅者',
  '夜羽华章',
  'LunaKnight',
  '天剑飞天',
  '穹顶之眼',
  '星门守望',
  '蓝翼旅人',
  '月华领航',
  '风中星语',
  '白昼辰光',
  '天空铭文',
  '遥远星灯',
  '云上之剑',
  '流光航路',
];
const globalNames = [
  'AstralEcho',
  'Northwind',
  'Skyward',
  'Moonlit',
  'Dawnkeeper',
  'CloudAtlas',
  'Starlance',
  'BlueHorizon',
  'NovaWing',
  'AetherSong',
  'Solaris',
  'Nightglow',
  'Windrunner',
  'Starbound',
  'AuroraVale',
  'Celestine',
  'OrionPath',
  'VegaLight',
  'Cloudspire',
  'Daybreak',
];

function buildPlayers(region: SkyspireRegion, count: number, names: string[]): SkyspirePlayer[] {
  return Array.from({ length: count }, (_, index) => ({
    id: `${region}-${index + 1}`,
    region,
    server: `S${((index * 7) % 48) + 1}`,
    name: index < names.length ? names[index] : `${names[index % names.length]}${Math.floor(index / names.length) + 1}`,
    platform: region,
    zoneId: index + 1,
    srvId: `${region}_${index + 1}`,
    zoneName: `S${((index * 7) % 48) + 1}`,
    querySuccess: true,
    rid: index + 1,
    roleSrvId: `${region}_${index + 1}`,
    account: `${region}-mock-${index + 1}`,
    reachTime: Math.floor(Date.UTC(2026, 7, 10 - index) / 1000),
    reachDurationSeconds: (index + 6) * 86400,
    rewardStatus: 0,
    rewardTime: 0,
  }));
}

export const skyspireFixture: Record<SkyspireRegion, SkyspirePlayer[]> = {
  hk: buildPlayers('hk', 56, hkNames),
  global: buildPlayers('global', 24, globalNames),
};
